export function isAllowedLogoutRedirectUrl(
  returnUrl: string | null,
  allowedLogoutRedirectUrls: string[]
): boolean {
  if (!returnUrl) return false;
  // Reject protocol-relative (//), backslash-relative (/\), and any backslash
  // anywhere — decoded %5C becomes \ and browsers normalise /\foo to //foo.
  if (/^\/(?![/\\])/.test(returnUrl) && !returnUrl.includes('\\')) return true;
  try {
    const { origin, pathname } = new URL(returnUrl);
    return allowedLogoutRedirectUrls.some((allowed) => {
      try {
        const a = new URL(allowed);
        return (
          a.origin === origin &&
          a.pathname.replace(/\/$/, '') === pathname.replace(/\/$/, '')
        );
      } catch {
        return false;
      }
    });
  } catch {
    return false;
  }
}
